// extracted by mini-css-extract-plugin
module.exports = {"DebugMobileText":"DebugMobileText_DebugMobileText__MsCUX","text":"DebugMobileText_text__xzXiW"};